import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './user-truck-implement.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const UserTruckImplementDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const userTruckImplementEntity = useAppSelector(state => state.userTruckImplement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userTruckImplementDetailsHeading">
          <Translate contentKey="fleetSenseApp.userTruckImplement.detail.title">UserTruckImplement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userTruckImplementEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="fleetSenseApp.userTruckImplement.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{userTruckImplementEntity.startDate ? <TextFormat value={userTruckImplementEntity.startDate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="fleetSenseApp.userTruckImplement.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{userTruckImplementEntity.endDate ? <TextFormat value={userTruckImplementEntity.endDate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="activated">
              <Translate contentKey="fleetSenseApp.userTruckImplement.activated">Activated</Translate>
            </span>
          </dt>
          <dd>{userTruckImplementEntity.activated ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.userTruckImplement.user">User</Translate>
          </dt>
          <dd>{userTruckImplementEntity.user ? userTruckImplementEntity.user.login : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.userTruckImplement.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{userTruckImplementEntity.truckImplement ? userTruckImplementEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.userTruckImplement.company">Company</Translate>
          </dt>
          <dd>{userTruckImplementEntity.company ? userTruckImplementEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-truck-implement" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-truck-implement/${userTruckImplementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserTruckImplementDetail;
